import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ProvidersServices } from "../../providers/services";
import { ProvidersCreateDataPage } from "../../providers/providers-create/providers-create-data/providers-create-data";
import { ImportExcelPage } from "../../components/import-excel/import-excel";
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-stock-provider-list',
    templateUrl: 'stock-provider-list.html',
})
export class StockProviderListPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' },
        { prop: 'phone', dir: 'asc' },
        { prop: 'email', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public providersServices: ProvidersServices,
        public globals: Globals,
        public translate: TranslateService) {

        this.globals.GAtrackView('Providers', 'Providers - List', this.globals.restaurant.email, 'View', 'List providers', 'Providers', '');
    }

    ionViewWillEnter() {
        this.providersServices.getPagesProvider(false);
    }


    openProviderCreate() {
        this.navCtrl.push(ProvidersCreateDataPage);
    }

    openProviderEdit(provider) {

        if (provider._active) {
            this.navCtrl.push(ProvidersCreateDataPage, {
                update_state: true,
                provider_uid: provider.UID,
                name: provider.name,
                contact_name: provider.contact_name,
                nif: provider.nif,
                email: provider.email,
                phone: provider.phone,
                country: provider.country,
                province: provider.province,
                city: provider.city,
                address: provider.address,
                fixed_phone: provider.fixed_phone,
                web: provider.web,
                cp: provider.cp,
                no_provider: provider.no_provider,
                observations: provider.observations,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    importProviders(type) {
        this.navCtrl.push(ImportExcelPage, {
            type: type
        });
    }

    onSort(event) {
        var providers_array = this.providersServices.providers_array_filtered;
        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    providers_array.sort((a, b) => a.name.localeCompare(b.name));
                } else {
                    providers_array.sort((a, b) => b.name.localeCompare(a.name));
                }
                break;
            case 'phone':
                if (event.newValue == 'asc') {
                    providers_array.sort((a, b) => a.phone - b.phone);
                } else {
                    providers_array.sort((a, b) => b.phone - a.phone);
                }
                break;
            case 'email':
                providers_array.sort((a, b) => {
                    // Usar el operador de coalescencia nula
                    if (a.email && b.email) {
                        return event.newValue === 'asc' ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email);
                    } else {
                        return 0;
                    }
                });
                break;
        }
        this.providersServices.providers_array_filtered = providers_array;
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.openProviderEdit(event.row);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/stock/stock-provider-list/stock-provider-list.ts